import {
    TimeReportGroupBy,
    TimeReportIsBillableFilter,
    TimeReportType
} from "../../../../../../views/reports/time-reports/@types";
import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";


export default class ReportTimeReports_Settings {

    public groupBy          : TimeReportGroupBy
    public daterange        : DateRange
    public projectId        : ID | null
    public userIds          : ID[]
    public taskTypeIds      : ID[]
    public timeReportType   : TimeReportType

    public isBillableFilter : TimeReportIsBillableFilter

    constructor(data: any) {
        this.groupBy            = _.get(data, "groupBy", TimeReportGroupBy.PROJECT)
        this.daterange          = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.projectId          = _.get(data, "projectId", null)
        this.userIds            = _.get(data, "userIds", [])
        this.taskTypeIds        = _.get(data, "taskTypeIds", [])
        this.timeReportType     = _.get(data, "timeReportType", TimeReportType.REPORTED)
        this.isBillableFilter   = _.get(data, "isBillableFilter", TimeReportIsBillableFilter.ALL)
    }

    // Mojet ne syuda dobavim ?!
    get reportTitle() {
        let title = ""

        if (this.projectId) {
            title += gd.session.projects.get(this.projectId)!.name
            title += " / "
        }

        title += formatDaterange(this.daterange)

        return title
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            groupBy             :   this.groupBy,
            projectId           :   this.projectId,
            userIds             :   this.userIds,
            taskTypeIds         :   this.taskTypeIds,
            timeReportType      :   this.timeReportType,
            isBillableFilter    :   this.isBillableFilter,
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
